<div class="group-list-container">

  <!-- Header with Add Button -->
  <div class="groups-header">
    <h3>Grupos de Aprobación</h3>
    <p>Gestión de grupos por ingresos y condiciones laborales</p>
    <button class="btn btn-primary add-group-btn" (click)="startCreatingGroup()">
      <i class="fas fa-plus"></i>
      Crear Nuevo Grupo
    </button>
  </div>

  <!-- New Group Form -->
  <div *ngIf="creatingGroup" class="new-group-form">
    <div class="form-card">
      <div class="form-header">
        <h4><i class="fas fa-plus-circle"></i> Crear Nuevo Grupo</h4>
        <button class="btn btn-sm btn-outline-secondary" (click)="cancelCreatingGroup()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="form-body">
        <div class="form-group">
          <label for="groupName" class="form-label">
            <i class="fas fa-tag"></i>
            Nombre del Grupo *
          </label>
          <input
            type="text"
            id="groupName"
            class="form-control"
            [(ngModel)]="newGroupForm.name"
            placeholder="Ej: Profesionales Independientes"
            required>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="minIncome" class="form-label">
              <i class="fas fa-dollar-sign"></i>
              Ingreso Mínimo ($) *
            </label>
            <input
              type="number"
              id="minIncome"
              class="form-control"
              [(ngModel)]="newGroupForm.minIncome"
              placeholder="250"
              min="1"
              required>
          </div>

          <div class="form-group">
            <label for="maxIncome" class="form-label">
              <i class="fas fa-dollar-sign"></i>
              Ingreso Máximo ($) *
            </label>
            <input
              type="number"
              id="maxIncome"
              class="form-control"
              [(ngModel)]="newGroupForm.maxIncome"
              placeholder="10000"
              min="1"
              required>
          </div>
        </div>

        <!-- =====================================================
             NUEVOS CAMPOS: Límites de Edad
             ===================================================== -->
        <div class="form-row">
          <div class="form-group">
            <label for="minAge" class="form-label">
              <i class="fas fa-birthday-cake"></i>
              Edad Mínima (años) *
            </label>
            <input
              type="number"
              id="minAge"
              class="form-control"
              [(ngModel)]="newGroupForm.minAge"
              placeholder="26"
              min="15"
              max="100"
              required>
            <small class="text-muted">Entre 15 y 100 años</small>
          </div>

          <div class="form-group">
            <label for="maxAge" class="form-label">
              <i class="fas fa-birthday-cake"></i>
              Edad Máxima (años) *
            </label>
            <input
              type="number"
              id="maxAge"
              class="form-control"
              [(ngModel)]="newGroupForm.maxAge"
              placeholder="70"
              min="15"
              max="100"
              required>
            <small class="text-muted">Entre 15 y 100 años</small>
          </div>
        </div>

        <!-- Form Preview -->
        <div *ngIf="isNewGroupFormValid()" class="form-preview">
          <div class="preview-card">
            <h5>Vista Previa del Grupo</h5>
            <div class="preview-info">
              <div class="preview-item">
                <strong>Nombre:</strong> {{ newGroupForm.name }}
              </div>
              <div class="preview-item">
                <strong>Ingresos:</strong>
                {{ formatIncome(newGroupForm.minIncome) }} - {{ formatIncome(newGroupForm.maxIncome) }}
              </div>
              <div class="preview-item">
                <strong>Edades:</strong>
                {{ newGroupForm.minAge }} - {{ newGroupForm.maxAge }} años
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="cancelCreatingGroup()">
          <i class="fas fa-times"></i>
          Cancelar
        </button>

        <button
          type="button"
          class="btn btn-success"
          (click)="createGroup()"
          [disabled]="!isNewGroupFormValid()">
          <i class="fas fa-save"></i>
          Crear Grupo
        </button>
      </div>
    </div>
  </div>

  <!-- Groups List -->
  <div class="groups-list">
    <div *ngIf="approvalGroups.length === 0" class="empty-state">
      <i class="fas fa-users"></i>
      <h4>No hay grupos de aprobación</h4>
      <p>Crea tu primer grupo de aprobación para comenzar a gestionar las políticas.</p>
    </div>

    <!-- Group Accordion -->
    <div *ngFor="let group of approvalGroups" class="group-accordion">

      <!-- Group Header (Always Visible) -->
      <div class="group-header" (click)="toggleGroup(group.name)">
        <div class="group-info">
          <div class="group-title">
            <i class="fas fa-users"></i>
            <span>{{ group.name }}</span>
            <span class="group-status" [style.background-color]="getGroupStatusColor(group.isActive)">
              {{ group.isActive ? 'Activo' : 'Inactivo' }}
            </span>
          </div>
          <div class="group-summary">
            <span class="income-range">
              <i class="fas fa-dollar-sign"></i>
              {{ formatIncome(group.minIncome) }} - {{ formatIncome(group.maxIncome) }}
            </span>
            <span class="conditions-count">
              <i class="fas fa-briefcase"></i>
              {{ group.workingConditions.length }} condiciones
            </span>
          </div>
        </div>

        <div class="group-toggle">
          <i class="fas" [class.fa-chevron-down]="isGroupExpanded(group.name)"
                      [class.fa-chevron-right]="!isGroupExpanded(group.name)"></i>
        </div>
      </div>

      <!-- Group Body (Collapsible) -->
      <div *ngIf="isGroupExpanded(group.name)" class="group-body">
        <div class="group-details">

          <!-- Income Limits Section -->
          <div class="section">
            <div class="section-header">
              <h5><i class="fas fa-dollar-sign"></i> Límites de Ingresos</h5>
              <button
                *ngIf="!isEditingGroup(group.name)"
                class="btn btn-xs btn-outline-primary"
                (click)="startEditingIncomeLimits(group)">
                <i class="fas fa-edit"></i>
                Editar
              </button>
            </div>

            <!-- View Mode -->
            <div *ngIf="!isEditingGroup(group.name)" class="income-limits">
              <div class="limit-item">
                <label>Mínimo:</label>
                <span class="limit-value">{{ formatIncome(group.minIncome) }}</span>
              </div>
              <div class="limit-item">
                <label>Máximo:</label>
                <span class="limit-value">{{ formatIncome(group.maxIncome) }}</span>
              </div>
            </div>

            <!-- Edit Mode -->
            <div *ngIf="isEditingGroup(group.name)" class="income-edit-form">
              <div class="edit-row">
                <div class="form-group">
                  <label>Ingreso Mínimo ($)</label>
                  <input
                    type="number"
                    class="form-control"
                    [(ngModel)]="editIncomeLimitsForm[group.name].minIncome"
                    min="1">
                </div>
                <div class="form-group">
                  <label>Ingreso Máximo ($)</label>
                  <input
                    type="number"
                    class="form-control"
                    [(ngModel)]="editIncomeLimitsForm[group.name].maxIncome"
                    min="1">
                </div>
              </div>
              <div class="edit-actions">
                <button
                  class="btn btn-sm btn-secondary"
                  (click)="cancelEditingIncomeLimits(group.name)">
                  <i class="fas fa-times"></i>
                  Cancelar
                </button>
                <button
                  class="btn btn-sm btn-success"
                  (click)="saveIncomeLimits(group.name)">
                  <i class="fas fa-save"></i>
                  Guardar
                </button>
              </div>
            </div>
          </div>

          <!-- =====================================================
               NUEVA SECCIÓN: Límites de Edad
               ===================================================== -->
          <div class="section">
            <div class="section-header">
              <h5><i class="fas fa-birthday-cake"></i> Límites de Edad</h5>
              <button
                *ngIf="!isEditingGroupAge(group.name)"
                class="btn btn-xs btn-outline-primary"
                (click)="startEditingAgeLimits(group)">
                <i class="fas fa-edit"></i>
                Editar
              </button>
            </div>

            <!-- View Mode -->
            <div *ngIf="!isEditingGroupAge(group.name)" class="age-limits">
              <div class="limit-item">
                <label>Edad Mínima:</label>
                <span class="limit-value">{{ group.minAge || 26 }} años</span>
              </div>
              <div class="limit-item">
                <label>Edad Máxima:</label>
                <span class="limit-value">{{ group.maxAge || 70 }} años</span>
              </div>
            </div>

            <!-- Edit Mode -->
            <div *ngIf="isEditingGroupAge(group.name)" class="age-edit-form">
              <div class="edit-row">
                <div class="form-group">
                  <label>Edad Mínima (años)</label>
                  <input
                    type="number"
                    class="form-control"
                    [(ngModel)]="editAgeLimitsForm[group.name].minAge"
                    min="15"
                    max="100"
                    placeholder="26">
                  <small class="text-muted">Entre 15 y 100 años</small>
                </div>
                <div class="form-group">
                  <label>Edad Máxima (años)</label>
                  <input
                    type="number"
                    class="form-control"
                    [(ngModel)]="editAgeLimitsForm[group.name].maxAge"
                    min="15"
                    max="100"
                    placeholder="70">
                  <small class="text-muted">Entre 15 y 100 años</small>
                </div>
              </div>
              <div class="edit-actions">
                <button
                  class="btn btn-sm btn-secondary"
                  (click)="cancelEditingAgeLimits(group.name)">
                  <i class="fas fa-times"></i>
                  Cancelar
                </button>
                <button
                  class="btn btn-sm btn-success"
                  (click)="saveAgeLimits(group.name)">
                  <i class="fas fa-save"></i>
                  Guardar
                </button>
              </div>
            </div>
          </div>

          <!-- Working Conditions Section -->
          <div class="section">
            <h5><i class="fas fa-briefcase"></i> Condiciones Laborales ({{ group.workingConditions.length }})</h5>

            <!-- Add Condition Form -->
            <div class="add-condition-form" *ngIf="availableWorkConditions.length > 0">
              <div class="form-group">
                <label>Agregar Condición:</label>
                <div class="input-group">
                  <select class="form-control" [(ngModel)]="selectedConditionToAdd">
                    <option [value]="null">Seleccione una condición...</option>
                    <option *ngFor="let condition of availableWorkConditions" [value]="condition">
                      {{ condition }}
                    </option>
                  </select>
                  <button
                    class="btn btn-sm btn-success"
                    (click)="addConditionToGroup(group)"
                    [disabled]="!selectedConditionToAdd">
                    <i class="fas fa-plus"></i>
                    Agregar
                  </button>
                </div>
              </div>
            </div>

            <!-- Conditions List -->
            <div class="conditions-list">
              <div *ngIf="group.workingConditions.length === 0" class="empty-conditions">
                <i class="fas fa-info-circle"></i>
                No hay condiciones laborales asignadas a este grupo
              </div>

              <span
                *ngFor="let condition of group.workingConditions"
                class="condition-chip">
                {{ condition }}
                <button
                  class="chip-remove"
                  (click)="removeConditionFromGroup(group.name, condition)"
                  title="Remover condición">
                  <i class="fas fa-times"></i>
                </button>
              </span>
            </div>
          </div>

          <!-- Danger Zone -->
          <div class="section danger-zone">
            <h5><i class="fas fa-exclamation-triangle"></i> Zona de Peligro</h5>
            <div class="danger-content">
              <p>Eliminar este grupo de aprobación es una acción permanente.</p>
              <button
                class="btn btn-sm btn-danger"
                (click)="deleteGroup(group)"
                [disabled]="group.workingConditions.length > 0">
                <i class="fas fa-trash"></i>
                Eliminar Grupo
              </button>
              <div *ngIf="group.workingConditions.length > 0" class="warning-message">
                <i class="fas fa-info-circle"></i>
                Debe remover todas las condiciones laborales antes de eliminar el grupo
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

</div>
